import { render, staticRenderFns } from "./divider-text.mpx?vue&type=template&id=6d4e1791&isComponent&outputPath=components%2Fdivider-text5a8a838c%2Findex"
import script from "./divider-text.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdivider-text5a8a838c%2Findex"
export * from "./divider-text.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdivider-text5a8a838c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports